"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { usePathname, useSearchParams } from "next/navigation";
import type * as React from "react";
import { Suspense } from "react";
import { ConvexClientProvider } from "./convex-client-provider";
import { HydrationProvider } from "./hydration-context";
const CONVEX_ENABLED_PATHS = new Set(["/admin/brands", "/guestbook-demo", "/pagination-demo"]);
const PUBLIC_MARKETING_PATHS = new Set(["/demo"]);
function isThemePreviewEnabled(searchParams: {
  get: (key: string) => string | null;
} | null) {
  const previewValue = searchParams?.get("previewTheme");
  return previewValue === "1" || previewValue === "true" || previewValue === "themes";
}
function isBrandedPublicPath(pathname: string | null) {
  if (pathname === null || pathname === "/") {
    return false;
  }
  const segments = pathname.split("/").filter(Boolean);
  return segments.length === 1 && !PUBLIC_MARKETING_PATHS.has(pathname);
}
function ProvidersInner(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t1 = isThemePreviewEnabled(searchParams) || pathname !== null && (CONVEX_ENABLED_PATHS.has(pathname) || !PUBLIC_MARKETING_PATHS.has(pathname) && !isBrandedPublicPath(pathname) && pathname !== "/");
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const enableConvexProvider = t1;
  let t2;
  if ($[3] !== children || $[4] !== enableConvexProvider) {
    t2 = enableConvexProvider ? <ConvexClientProvider enableAuth={false}>{children}</ConvexClientProvider> : children;
    $[3] = children;
    $[4] = enableConvexProvider;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function Providers(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ProvidersInner>{children}</ProvidersInner>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <HydrationProvider><NextThemesProvider attribute="class" defaultTheme="system" enableSystem={true} enableColorScheme={true}><Suspense fallback={children}>{t1}</Suspense></NextThemesProvider></HydrationProvider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}